<template>
  <div>
    <div id="login" v-if="$route.path == '/login'">
      <router-view />
    </div>
    <div id="app" v-else>
      <div id="sidebar">
        <div class="sidebar-wrapper">
          <h1>
            <img src="./assets/logo.png" width="150" />
            <!-- <span>(beta)</span> -->
          </h1>
          <div class="toko">
            <div>
              <outlet />
            </div>
            <div>
              <label for="">
                <strong>{{ $user.nama }}</strong>
              </label>

              <span class="paket">{{ namaPaket }}</span>
            </div>
          </div>

          <div class="all-outlet" @click="outletOpen = !outletOpen" :class="outletOpen ? 'active' : ''">
            <div style="display: flex; justify-content: space-between">
              <p style="font-size: 14px; margin: 0">{{ $toko.nama }}</p>
              <chevron />
            </div>

            <div class="detail">
              <ul>
                <li v-show="loadingOutlet">
                  <div>
                    <p>Loading outlet...</p>
                  </div>
                </li>
                <li v-for="(item, index) in allOutlet" :key="index" @click.stop="loginToken(item)">
                  <div>
                    <p>
                      <b>{{ item.nama }}</b>
                    </p>
                    <small>{{ item.alamat }}</small>
                    <small>{{ item.no_telp }}</small>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="sidebar-menu">
            <ul>
              <li v-for="(item, index) in aksesMenu" :key="index"
                :class="item.id_parent ? 'sub ' + 'sub-' + item.id_parent : ''" @click="(e) => {
      toggleMenu(item, e);
    }
      ">
                <a href="javascript:void(0)" @click="navigateTo(item)" :class="(item.hasChildren ? 'parent ' : '') +
      (currentUrl == item.url ? 'actives ' : '')
      ">
                  {{ item.menu }}
                  <chevron v-if="item.hasChildren" :class="{ open: item.active }" />
                </a>
                <ul v-if="item.hasChildren" :class="{ active: item.active }">
                  <li v-for="(child, key) in item.children" :key="key">
                    <a href="javascript:void(0)" @click="navigateTo(child)"
                      :class="currentUrl.includes(child.url) ? 'active' : ''">
                      {{ child.menu }}
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div id="main">
        <div id="navbar">
          <div></div>
          <div class="logout" @click="logout">
            <div>Logout
              <logout />
            </div>
          </div>
        </div>
        <div id="content">
          <router-view class="router" />
        </div>
        <div id="footer">Serve by <b>Restoku</b> - 2022</div>
      </div>
    </div>

    <div class="toast" :class="{ open: toast.open }">
      <div class="toast-body">
        <info />
        <p>{{ toast.text }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Outlet from "./components/icons/Outlet.vue";
import Logout from "./components/icons/Logout.vue";
import Info from "./components/icons/Info.vue";
import Chevron from "./components/icons/Chevron.vue";

import * as api from "./api/Api";

export default {
  name: "App",
  components: {
    Outlet,
    Logout,
    Info,
    Chevron,
  },
  data() {
    return {
      namaPaket: "",
      aksesMenu: [],
      currentUrl: "",

      loadingOutlet: false,
      allOutlet: [],
      outletOpen: false,
    };
  },
  computed: {
    toast() {
      return this.$store.state.settings.toast || {};
    },
  },
  methods: {
    navigateTo(item) {
      if (item.hasChildren) {
        item.open = !item.open;
      }
      if (item.url) {
        this.$router.push(item.url);
        this.currentUrl = location.pathname;
      }
    },
    logout() {
      localStorage.clear();
      location.href = "/#/login";
    },
    toggleMenu(item, e) {
      if (e.target.classList[0] == "parent") {
        item.active = !item.active;
      }
    },
    loginToken(toko) {
      this.$store.commit("settings/setToko", toko);
      location.reload();
    },
    loadAksesMenu(id_hak_akses) {
      this.aksesMenu = this.$store.state.aksesMenu.data;

      api
        .get(
          "/v4/setting/user-akses?id=" +
          id_hak_akses +
          "&id_toko=" +
          this.$toko.id +
          "&desktop=1"
        )
        .then((r) => {
          this.loading = false;

          this.aksesMenu = [];
          const menu = r.data.detail;

          const menuParent = menu.filter((k) => {
            return k.id_parent == null;
          });

          menuParent.forEach((item) => {
            const menuChildren = menu.filter((k) => {
              return k.id_parent == item.id_menu;
            });

            if (menuChildren.length > 0) {
              item.hasChildren = true;
              item.active = false;
              item.children = menuChildren;
            }

            this.aksesMenu.push(item);
          });

          this.$store.commit("aksesMenu/save", this.aksesMenu);
        })
        .catch((e) => {
          this.loading = false;
          this.$toast("Gagal mengambil data");
        });
    },
    getPaket() {
      this.namaPaket = this.$store.state.settings.namaPaket;

      api.get("/v4/toko/paket?token=" + this.$toko.token).then((r) => {
        this.namaPaket = r.data.nama_paket.toUpperCase();
        this.$store.commit("settings/setNamaPaket", this.namaPaket);

        if (r.data.id_paket == 2) {
          alert('Anda berlangganan Restoku versi LITE, tidak dapat mengakses Backoffice');
          this.logout();
        }
      });
    },
    loadAllOutlet() {
      this.loadingOutlet = true;
      api.get("/v4/toko/all-outlet?id=" + this.$user.id_toko).then((r) => {
        this.allOutlet = r.data;
        this.loadingOutlet = false;
      });
    },
  },
  mounted() {
    if (this.$route.path != "/login") {
      this.getPaket();
      this.loadAllOutlet();

      const akses = this.$store.state.aksesMenu.data.find((item) => {
        return item.url == this.currentUrl;
      });

      this.loadAksesMenu(1);

      if (!akses) {
        // check last parameter
        // const slug = this.currentUrl.split("/")
        // console.log(parseInt(slug[slug.length - 1]))
        // this.$router.push("/forbidden");
      }
    }

    if (!this.$store.state.settings.isLogin) {
      if (this.$route.path != "/login") {
        this.$router.push("/login");
      }
    }

    // this.aksesMenu = this.$store.state.aksesMenu.data;

    // let tmpGroup = "Dashboard";
    // this.$store.state.aksesMenu.data.forEach((item) => {
    //   if (item.group != tmpGroup) {
    //     item.separator = true;
    //   }
    //   this.aksesMenu.push(item);

    //   tmpGroup = item.group;
    // });
  },
  watch: {
    $route(to) {
      this.currentUrl = to.path;
    },
  },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Maven+Pro:wght@400;600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Wix+Madefor+Text:wght@500;700&display=swap');

:root {
  --white: #fff;
  --green: #4caf50;
  --primary-disabled: #79c3ff;
  --primary: #2196f3; // #0095cf; //
  --primary-darker: #1a87e0;
  --red: #e9361f;
  --red-disabled: #e97b6c;
  --red-darker: #ad2c04;
  --light-blue: #e3f2fd;
  --orange: #f77a00;
}

body {
  margin: 0;
}

* {
  font-family: "Maven Pro", sans-serif;
  // font-family: 'Wix Madefor Text', sans-serif;
}

#app {
  background: #f1f3f6;
  display: grid;
  grid-template-columns: 250px 1fr;

  #sidebar {
    .sidebar-wrapper {
      margin: 20px 5px 20px 20px;
    }

    .paket {
      background: var(--primary);
      font-size: 12px;
      color: #fff;
      padding: 5px 10px;
      border-radius: 6px;
      font-weight: 700;
    }

    .toko {
      display: grid;
      grid-template-columns: 60px 1fr;

      label {
        display: block;
        margin-bottom: 5px;
      }

      select {
        padding: 6px;
      }
    }

    h1 {
      color: var(--primary);
      position: relative;

      span {
        position: absolute;
        color: #333;
        font-size: 14px;
        margin-left: 4px;
        margin-top: 10px;
      }
    }

    .sidebar-menu {
      margin-top: 20px;
      height: calc(100vh - 260px);
      overflow-y: auto;
      overflow-x: hidden;

      >ul {
        list-style-type: none;
        padding: 0;
        margin: 0;

        >li {
          >a {
            display: grid;
            grid-template-columns: 1fr 20px;
            align-items: center;
            color: #333;
            text-decoration: none;
            padding: 10px 0px;
            font-size: 15px;

            &:hover,
            &.active {
              color: var(--primary);
            }

            .icon {
              transform: rotate(90deg);
              margin-left: -5px;

              &.open {
                transform: rotate(-90deg);
                margin-left: 0;
              }
            }
          }

          >ul {
            list-style-type: none;
            overflow: hidden;
            max-height: 0;
            padding-left: 20px;

            &.active {
              max-height: 100%;
            }

            li {
              a {
                display: block;
                align-items: center;
                color: #333;
                text-decoration: none;
                padding: 10px 0px;
                font-size: 15px;

                &:hover,
                &.active {
                  color: var(--primary);
                  font-weight: 700;
                }
              }
            }
          }
        }
      }
    }
  }

  #main {
    padding: 8px 15px 0;

    #navbar {
      padding: 15px 0px;
      display: flex;
      justify-content: space-between;

      span {
        cursor: pointer;
      }

      .logout {
        cursor: pointer;
        display: block;

        >div {
          display: flex;
          font-size: 14px;
          font-weight: 600;

          div {
            margin-left: 10px;
          }
        }
      }
    }

    #content {
      width: 100%;
      border-radius: 5px;
      background: #fff;
      border: 1px solid #ddd;

      .router {
        width: 100%;
        height: calc(100vh - 110px);
        overflow: auto;
      }
    }

    #footer {
      padding: 15px 0px;
      font-size: 12px;
    }
  }

  .table-wrapper {
    overflow: auto;
    border: 1px solid #ccc;
  }

  table.table {
    width: 100%;
    border-collapse: collapse;
    font-size: 15px;

    thead {
      tr {
        th {
          position: sticky;
          top: 0;
          background-color: #eee;
          padding: 10px;
          text-align: left;
        }
      }
    }

    tbody {
      tr {
        cursor: pointer;

        &:hover {
          td {
            background-color: #f7f7f7;
          }

          &.no-hover {
            td {
              background-color: #fff;
              cursor: default;
            }
          }
        }

        td {
          padding: 10px;
          border-bottom: 1px solid #ccc;
          font-size: 14px;
        }

        &:last-child {
          td {
            border-bottom: 0;
          }
        }
      }

      span.btn-hapus {
        color: var(--red);
        text-align: right;
        display: block;
        font-size: 14px;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  .card {
    border-radius: 10px;
    box-shadow: 0px 0px 3px #ccc;

    &.card-primary {
      box-shadow: 0px 0px 3px var(--primary) !important;
    }

    .card-body {
      padding: 15px;
    }
  }
}

.all-outlet {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 15px;
  margin-top: 10px;
  position: relative;
  cursor: pointer;

  &:active {
    background-color: #eee;
  }

  p {
    font-size: 14px;
    margin: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .icon {
    transform: rotate(90deg);
  }

  &.active {
    >div.detail {
      display: block;
    }

    .icon {
      transform: rotate(-90deg);
    }
  }

  div.detail {
    position: absolute;
    border: 1px solid #ddd;
    width: 100%;
    margin-top: 14px;
    left: -1px;
    background: #fff;
    display: none;
    z-index: 9;

    ul {
      list-style-type: none;
      padding: 0;
      margin: 0;

      li {
        padding: 15px;
        border-bottom: 1px solid #ddd;

        &:active {
          background: #eee;
        }

        p {
          margin: 0;
          font-size: 14px;
        }

        small {
          display: block;
          font-size: 12px;
          color: #555;
        }
      }
    }
  }
}

.btn-bar {
  display: flex;
  justify-content: space-between;
}

.form-group {
  margin-bottom: 15px;

  label {
    font-size: 14px;
    display: block;
    margin-bottom: 5px;
  }
}

input,
select,
textarea {
  background: #fff;
  border: 1px solid #ccc;
  outline: none;
  padding: 10px 6px;
  border-radius: 4px;
  width: 100%;
  font-size: 14px;

  &:focus {
    border: 1px solid var(--primary);
  }
}

input,
textarea {
  padding: 12px 10px;
  width: calc(100% - 20px);
}

input[type="date"] {
  padding: 9px 10px;
}

button {
  cursor: pointer;
}

.btn-fill {
  background: var(--primary);
  border: 1px solid var(--primary);
  color: #fff;
  padding: 11px 20px;
  border-radius: 4px;
  width: 100%;
  text-align: center;
  font-weight: 700;
  text-transform: uppercase;
  outline: none;
  font-size: 14px;
  text-decoration: none;

  &:active {
    background: var(--primary-darker);
  }

  &:disabled {
    background: var(--primary-disabled);
  }
}

.btn-outline {
  background: #fff;
  border: 1px solid var(--primary);
  color: var(--primary);
  padding: 12px 20px;
  border-radius: 4px;
  width: 100%;
  text-align: center;
  font-weight: 700;
  text-transform: uppercase;
  outline: none;

  &:active {
    background: #eee;
  }

  &:disabled {
    opacity: 0.5;
  }

  &.green {
    border-color: var(--green);
    color: var(--green);
  }
}

.btn-width-auto {
  width: auto;
}

.toast {
  position: absolute;
  top: -60px;
  right: 20px;
  background: #343a3f;
  border-radius: 6px;
  opacity: 0;
  transition: all 0.3s ease;

  &.open {
    top: 20px;
    opacity: 1;
  }

  &-body {
    padding: 15px;
    display: flex;
    align-items: center;
  }

  p {
    margin: 0;
    padding-left: 15px;
    color: #fff;
    font-size: 14px;
  }
}

@keyframes flickerAnimation {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

@-o-keyframes flickerAnimation {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

@-moz-keyframes flickerAnimation {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

@-webkit-keyframes flickerAnimation {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

.animate-flicker {
  -webkit-animation: flickerAnimation 1s infinite;
  -moz-animation: flickerAnimation 1s infinite;
  -o-animation: flickerAnimation 1s infinite;
  animation: flickerAnimation 1s infinite;
}

.badge-green {
  font-size: 12px;
  padding: 4px 10px;
  background-color: rgb(214, 255, 202);
  color: rgb(31, 141, 21);
  border-radius: 5px;
  margin-left: 4px;
  margin-top: -2px;
}
</style>
<style>
.vue-daterange-picker {
  display: block !important;
}

.daterangepicker:before,
.daterangepicker:after {
  border: 0;
}

.reportrange-text {
  padding: 10px !important;
  border-radius: 4px !important;
  font-size: 14px;
}

.daterangepicker.openscenter:before {
  margin-left: 0;
  margin-right: 0;
}

.daterangepicker.openscenter {
  left: unset !important;
  right: unset !important;
  transform: unset !important;
}

.toggle {
  --width: 150px;
  --height: calc(var(--width) / 4);

  position: relative;
  display: inline-block;
  width: var(--width);
  height: var(--height);
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  border-radius: 5px;
}

.toggle input {
  display: none;
}

.toggle .labels {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 14px;
  font-family: sans-serif;
  transition: all 0.4s ease-in-out;
  overflow: hidden;
  border-radius: 5px;
}

.toggle .labels::after {
  content: attr(data-off);
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  color: var(--primary);
  background-color: #fff;
  transition: all 0.4s ease-in-out;
  font-family: "Montserrat", sans-serif;
  font-size: 13px;
  font-weight: bold;
}

.toggle .labels::before {
  content: attr(data-on);
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: calc(var(--width) * -1);
  height: 100%;
  width: 100%;
  color: var(--primary);
  background-color: #fff;
  text-align: center;
  transition: all 0.4s ease-in-out;
  font-family: "Montserrat", sans-serif;
  font-size: 13px;
  font-weight: bold;
}

.toggle input:checked~.labels::after {
  transform: translateX(var(--width));
}

.toggle input:checked~.labels::before {
  transform: translateX(var(--width));
}

/* Customize the label (the container) */
.label-container {
  display: flex;
  position: relative;
  padding-top: 2px;
  padding-left: 30px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.label-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

/* On mouse-over, add a grey background color */
.label-container:hover input~.checkmark {
  background-color: #eee;
}

/* When the checkbox is checked, add a blue background */
.label-container input:checked~.checkmark {
  background-color: #2196f3;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.label-container input:checked~.checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.label-container .checkmark:after {
  left: 6px;
  top: 1px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>


// WEBPACK FOOTER //
// src/App.vue